module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('fieldset', {
    staticClass: "margin-b-10"
  }, [_c('legend', [_vm._v("UniMicro Environment")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Environment"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select UniMicro Environment"
    },
    model: {
      value: (_vm.form.fields.unimicro_environment.value),
      callback: function($$v) {
        _vm.$set(_vm.form.fields.unimicro_environment, "value", $$v)
      },
      expression: "form.fields.unimicro_environment.value"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Test",
      "value": "https://test.unimicro.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "UniMicro",
      "value": "https://app.unimicro.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "UniMicro SMB",
      "value": "https://smb.unimicro.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "DNB Regnskap",
      "value": "https://dnbregnskap.dnb.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Eika Regnskap",
      "value": "https://system.eikaregnskap.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Azets Complete",
      "value": "https://complete.azets.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Sør-Norge",
      "value": "https://regnskap.sb1sornorge.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Østlandet",
      "value": "https://regnskap.sb1ostlandet.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Nord-Norge",
      "value": "https://regnskap.snn.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Hallingdal Valdres",
      "value": "https://regnskap.sb1.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Nordmøre",
      "value": "https://regnskap.bank.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Østfold Akershus",
      "value": "https://regnskap.sparebank1oa.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Ringerike Hadeland",
      "value": "https://regnskap.rhbank.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Gudbrandsdal",
      "value": "https://regnskap.s1g.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 Regnskap Lom og Skjåk",
      "value": "https://regnskap.sb1ls.no"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "SB1 SMN",
      "value": "https://regnskap.smn.no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Invoice Number Series"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select Number Series for Kundan Invoices"
    },
    model: {
      value: (_vm.form.fields.unimicro_invoice_series_id.value),
      callback: function($$v) {
        _vm.$set(_vm.form.fields.unimicro_invoice_series_id, "value", $$v)
      },
      expression: "form.fields.unimicro_invoice_series_id.value"
    }
  }, _vm._l((_vm.numberSeriesOptions), function(opt) {
    return _c('el-option', {
      key: opt.value,
      attrs: {
        "label": opt.label,
        "value": opt.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveEnvironment
    }
  }, [_vm._v("\n        Update Settings\n      ")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e96c6ab","hasScoped":false}!./src/app/components/unimicroCredentialsModal/unimicroCredentialsModal.html
// module id = 2998
// module chunks = 1